import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import { message } from 'antd';
import { handleErrorNotification } from 'Common/utils';
import { useApiClient } from '../../utils/apiClient';

/* eslint-disable import/prefer-default-export */
export const useSettings = () => {
  const apiClient = useApiClient();
  return useQuery({
    queryKey: ['rksv', 'settings'],
    queryFn: apiClient.Rksv.getSettings,
  });
};

export const useSaveSettings = () => {
  const apiClient = useApiClient();
  const queryClient = useQueryClient();
  const intl = useIntl();
  return useMutation({
    mutationFn: apiClient.Rksv.postSettings,
    onSuccess: () => {
      queryClient.refetchQueries({ queryKey: ['rksv', 'settings'] });
      message.success(
        intl.formatMessage({ defaultMessage: 'Settings saved successfully' })
      );
    },
    onError: (error) => {
      handleErrorNotification({
        error,
        lang: intl.locale.toLowerCase(),
      });
    },
  });
};

export const useResetSettings = () => {
  const apiClient = useApiClient();
  const queryClient = useQueryClient();
  const intl = useIntl();
  return useMutation({
    mutationFn: apiClient.Rksv.resetSettings,
    onSuccess: () => {
      queryClient.refetchQueries({ queryKey: ['rksv', 'settings'] });
      message.success(
        intl.formatMessage({
          defaultMessage: 'Success! Cashbox data was successfully reset',
        })
      );
    },
    onError: (error) => {
      handleErrorNotification({
        error,
        lang: intl.locale.toLowerCase(),
      });
    },
  });
};

export const useInitialReceipt = () => {
  const apiClient = useApiClient();
  return useQuery({
    queryKey: ['rksv', 'initial-receipt'],
    queryFn: apiClient.Rksv.getInitalReceipt,
  });
};

export const useGenerateInitialReceipt = () => {
  const apiClient = useApiClient();
  const intl = useIntl();
  return useMutation({
    mutationFn: apiClient.Rksv.generateInitalReceipt,
    onSuccess: () => {
      message.success(
        intl.formatMessage({
          defaultMessage: 'Initial receipt generated successfully',
        })
      );
    },
    onError: (error) => {
      handleErrorNotification({
        error,
        lang: intl.locale.toLowerCase(),
      });
    },
  });
};
